import React from 'react'

import classNames from 'classnames'

import { IconWrapper } from '../components'

export const IconBill = ({
  size,
  color,
  className,
  ...props
}: React.ComponentPropsWithoutRef<'svg'> & {
  size?: string | number
}) => (
  <IconWrapper {...props} className={classNames(className, "icon-centivo", "icon-centivo--bill")} iconColor={color} size={size} width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
      <defs>
          <path d="M14 1a1 1 0 0 1 .707.293l6 6A1 1 0 0 1 21 8v12a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3V4a3 3 0 0 1 3-3h8zm-.414 2H6a1 1 0 0 0-1 1v16a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V8.414L13.586 3zM11.5 9a.5.5 0 0 1 .5.5l.001.725a4.35 4.35 0 0 1 1.84.647c.187.11.374.341.374.671a.78.78 0 0 1-.792.781.813.813 0 0 1-.429-.121c-.34-.2-.67-.348-.993-.433l-.002 1.608.049.013c1.562.407 2.442.968 2.442 2.31v.022c0 1.423-1.01 2.265-2.49 2.375v.402a.5.5 0 1 1-1 0v-.434a4.946 4.946 0 0 1-2.23-.88.791.791 0 0 1-.319-.638.78.78 0 0 1 .792-.781c.22 0 .374.077.484.154a3.5 3.5 0 0 0 1.273.613V14.82c-1.404-.38-2.296-.844-2.296-2.287v-.022c0-1.276.936-2.157 2.296-2.3V9.5a.5.5 0 0 1 .5-.5zm.502 6.105v1.49c.508-.072.805-.327.805-.707v-.022c0-.328-.155-.534-.805-.76zm-1.615-2.748v.022c0 .331.141.516.612.7v-1.354c-.403.093-.612.339-.612.632zM14 1a1 1 0 0 1 1 1v5h5a1 1 0 0 1 0 2h-6a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1z" id="icon--centivo--bill"/>
      </defs>
      <g fill="none" fillRule="evenodd">
          <use fill="currentColor" xlinkHref="#icon--centivo--bill"/>
      </g>
  </IconWrapper>
)
